itsoftApp.createModule("burger", ["windowResize"], function() {
    var burgerClass = "js-burger";
    var burger = $("." + burgerClass);

    if (!burger.length) {
        return false;
    }

    var burgerBg = $(".js-burger-bg");
    var activeClass = "is-active";
    var menuOpened = false;
    var $wrapper = itsoftApp.commonVars.$wrapper;
    var absClass = "is-abs";
    var menu = $(".js-menu");
    var transitionEventEnd = itsoftApp.features.transitionEventEnd;
    var contactsPopup = $("#contact");

    var openMenu = function() {
        burger.addClass(activeClass);
        burgerBg.addClass(activeClass);
        $wrapper.addClass(absClass);
        menu.addClass(activeClass);
        menuOpened = true;
        DEBUG && console.log("[module burger] menu opened")
    };

    var openContactsPopup = function() {
        contactsPopup.trigger("popups:open");
    };

    var closeMenu = function() {
        burgerBg.removeClass(activeClass);
        burger.removeClass(activeClass);
        $wrapper.removeClass(absClass);
        menu.removeClass(activeClass);
        menuOpened = false;


        DEBUG && console.log("[module burger] menu closed")
    };

    var resizeController = function() {
        if (menuOpened && !burger.is(":visible")) {
            closeMenu();
        }
    };

    // Binds
    burger.on("click", function(){
        var self = $(this);

        if (self.hasClass(activeClass) && menuOpened){
            closeMenu();
        }
        else{
            openMenu();
        }
    });


    var openContactsBtn = function() {
        burgerBg.one(transitionEventEnd, openContactsPopup);
        if (menuOpened){
            closeMenu();
        }
        else{
            openContactsPopup();
        }
    };
    $(".js-open-contacts").on("click", openContactsBtn)
    itsoftApp.modules.windowResize.addEvent(resizeController);

});